exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-container[data-v-4ca1ba13] {\n  max-width: 1000px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 16px;\n}", ""]);

// exports
